import {Injectable} from '@angular/core';
import {isNullOrUndefined} from 'util';

declare var _paq: any;

@Injectable()
export class PiwikService {

  // public methods for tracking info
  // these methods could be static, but we keep them public because instances of this class
  // are injected as dependencies, not the class itself
  public trackPage(path: string) {

    // https://developer.piwik.org/guides/tracking-javascript-guide

    // by pushing to the global _paq array, we send tracking info to piwik.
    // see index.html for the piwik code
    _paq.push(['setDocumentTitle', window.document.title]);
    _paq.push(['setCustomUrl', path]);
    _paq.push(['trackPageView']);

  }

  public trackEvent(category: string, action: string, properties?: any) {
    //https://piwik.org/docs/event-tracking/#tracking-events

    var request: any[] = ['trackEvent', category, action];

    if (!isNullOrUndefined(properties)) {

      if (properties.hasOwnProperty('name')) {
        request.push(properties['name']);
      }

      // value is an optional numeric value
      if (properties.hasOwnProperty('value')) {
        var parsed = parseInt(properties.value, 10);
        properties.value = isNaN(parsed) ? 0 : parsed;
        request.push(properties['value']);
      }
    }
    _paq.push(request);
  }
}
